import { useState, useEffect } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_REVISION } from '../../../../Constants';

export const useFetchMediaAccess = (active, refresh) => {
  const [mediaAccesssResponse, setMediaAccessResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMediaAccess = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await axiosService.get(
          `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_REVISION}?active=${active}&limit=100&page=1`
        );
        setMediaAccessResponse(response?.data);
      } catch (err) {
        console.error(err);
        setError(err.message || 'An error occurred while fetching revision access');
      } finally {
        setIsLoading(false);
      }
    };

    fetchMediaAccess();

  }, [active, refresh]); // Fetch media access whenever the 'active' parameter changes

  return [ mediaAccesssResponse, isLoading, error ];
};